import * as React from 'react'
import { ValueComponentProps } from '../../../props'

export default function UnknownValue({}: ValueComponentProps<any>) {
  return <>Unknown question type</>
}
